import { render, staticRenderFns } from "./CacheStaleNotice.vue?vue&type=template&id=42d8c3d4&scoped=true"
import script from "./CacheStaleNotice.vue?vue&type=script&lang=js"
export * from "./CacheStaleNotice.vue?vue&type=script&lang=js"
import style0 from "./CacheStaleNotice.vue?vue&type=style&index=0&id=42d8c3d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d8c3d4",
  null
  
)

export default component.exports